import { useQuery } from '@apollo/client'
import { subscriptionBillingInfo } from '../queries'

export const useBillingInfo = (cache = true) => {
  const fetchPolicy = cache ? 'cache-first' : 'no-cache'
  const queryOptions = { fetchPolicy, notifyOnNetworkStatusChange: true }
  return useQuery(subscriptionBillingInfo, queryOptions)
}
